// eslint-disable-next-line import/prefer-default-export
export const STUBS = {
  PC: {
    DISCONNECTED_NOTIFICATION_FROM_WL: 'disconnectedNotificationFromWl',
    // 打开答题统计
    // 当subPageName为'excercise_question'的时候打开题目列表tab
    EXCERCISE_DATA_TRANSPORT_FROM_WL: 'excerciseDataTransportFromWl',
    // 切换题目：点击上一题下一题的时候emit
    EXCERCISE_TOPIC_DATA_TRANSPORT_FROM_WL: 'excerciseTopicDataTransportFromWl',
    CHECKIN_DATA_TRANSPORT_FROM_WL: 'checkinDataTransportFromWl',
    CHECKIN_DATA_TAB_CHANGE_FROM_WL: 'checkinDataTabChangeFromWl',
    CLASSROOM_DATA_TRANSPORT_FROM_WL: 'classroomDataTransportFromWl',
    QUESTIONNAIRE_DATA_TRANSPORT_FROM_WL: 'questionnaireDataTransportFromWl',
    CALLROLL_DATA_TRANSPORT_FROM_WL: 'callrollDataTransportFromWl',
    CALLROLL_COUNTDOWN_DATA_TRANSPORT_FROM_WL:
      'callrollCountdownDataTransportFromWl',
    POST_DATA_TRANSPORT_FROM_WL: 'postDataTransportFromWl',
    ANNOUNCEMENT_DATA_TRANSPORT_FROM_WL: 'announcementDataTransportFromWl',
    LESSON_PLAN_DATA_TRANSPORT_FROM_WL: 'lessonPlanDataTransportFromWl',
    VIDEOTEACH_DATA_TRANSPORT_FROM_WL: 'videoteachDataTransportFromWl',
  },
  WL: {
    CONNECTED_NOTIFICATION_FROM_PC: 'connectedNotificationFromPC',
    DISCONNECT_SUCCESS_RESPONSE_FROM_PC: 'disconnectSuccessResponseFromPc',
    GET_CALLROLL_LIST_FROM_PC: 'getCallrollListFromPC',
  },
  SERVER: {
    GOTO_CURRENT_CLASSROOM_AFTER_SUCCESS_LOGIN_FROM_SERVER:
      'gotoCurrentClassroomAfterSuccessLoginFromServer',
    GET_ROOM_ID_FROM_SERVER: 'getRoomIdFromServer',
    DISSCONNECT_SIGNAL_FROM_SERVER: 'dissconnectSignalFromServer',
    DISCONNECT_SUCCESS_RESPONSE_FROM_SEVER:
      'disconnectSuccessResponseFromServer',
  },
};
